import React from 'react';
import EnrichmentScreen from './common/EnrichmentScreen';
import ButtonLink from '../../elements/ButtonLink';

export default class EnrichmentsHomeAlreadyVoted extends React.Component {
    render() {
        let {event, category, i18n, questions} = this.props;
        const hasResults = questions.filter(item => [2,3].includes(item.question.show_results)).length > 0;

        return <EnrichmentScreen event={event} enrichmentCategory={category}>
            <div className="text main text-center" style={{
                    padding: '10vh 15px',
                    textDecoration: 'underline',
                    fontSize: '180%'
                }}>
                {i18n['label.title.already.voted']}
            </div>
            {hasResults ? 
                <ButtonLink 
                    href={'./results'} 
                    style={Object.assign({}, event._local.styles.button, {
                            width: '80%',
                            margin: '0 auto',
                            fontSize: '150%'
                    })}
                >
                    {i18n['button.view.results']}
                </ButtonLink>
            :
            <ButtonLink 
            href={['/events', event.id].join('/')} 
            style={Object.assign({}, event._local.styles.button, {
                width: '80%', margin: '0 auto', fontSize: '150%',
            })}
            >
                {i18n['navigation.back']}
            </ButtonLink>
            }
            {/*  */}
        </EnrichmentScreen>;
    }
}
